import script from "./CourseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseHeader.vue?vue&type=script&setup=true&lang=js"

import "./CourseHeader.vue?vue&type=style&index=0&id=b2df2f66&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2df2f66"]])

export default __exports__